import type { ClientConfig } from "./types";
import localConfig from "../datas/settings-config.json";

export async function loadClientConfig(): Promise<ClientConfig> {
  return localConfig as unknown as ClientConfig;
}
